import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { UsersService } from "@shared/services/users/users.service";
import { combineLatest, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
	providedIn: "root"
})
export class AdminGuard implements CanActivate {
	constructor(private userService: UsersService) { }
	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		console.log('ADMIN GUARD');
		return combineLatest(
			[this.userService.isAdmin().pipe(catchError(err => of(err.error.code))),
			this.userService.isCustomerCenter().pipe(catchError((/* err */) => of(null)))])
			.pipe(
				map(result => (/* isAdmin */ result[0] || /* isCustomer */ result[1])))
			.pipe(
				catchError(err => {
					console.log(err);
					return of(false);
				})
			);
	}
}